module.exports = __webpack_public_path__ + "static/img/intro.b8c1cd47.png";